  // import React, { useEffect, useMemo, useState } from "react";
  // import AddMainCategoryModal from "./AddMainCategoryModal";
  // import "./mainCategories.css";

  // import { API_BASE } from "../../services/apiFetch";
  // import { useVendorAuth } from "../../store/vendorAuthStore";

  // export default function MainCategoriesPage() {
  //   const { token } = useVendorAuth();

  //   const [rows, setRows] = useState([]);
  //   const [q, setQ] = useState("");

  //   // add modal
  //   const [openAdd, setOpenAdd] = useState(false);

  //   // edit modal
  //   const [openEdit, setOpenEdit] = useState(false);
  //   const [editRow, setEditRow] = useState(null);

  //   const [viewImg, setViewImg] = useState("");
  //   const [loading, setLoading] = useState(false);

  //   const authHeaders = token ? { Authorization: "Bearer " + token } : {};

  //   /* ===========================
  //      ✅ LIST from DB
  //   ============================ */
  //   const loadCats = async () => {
  //     try {
  //       setLoading(true);

  //       const res = await fetch(`${API_BASE}/vendor/main_categories/list.php`, {
  //         headers: authHeaders,
  //       });

  //       const text = await res.text();
  //       let data = {};
  //       try {
  //         data = JSON.parse(text);
  //       } catch {
  //         data = {};
  //       }

  //       const list = data?.categories || data?.data || [];
  //       if (!res.ok || data?.success === false) {
  //         setRows([]);
  //         return;
  //       }

  //       const safe = Array.isArray(list) ? list : [];
  //       setRows(
  //         safe.map((r) => ({
  //           ...r,
  //           id: Number(r.id ?? r.category_id ?? 0),
  //           name: r.name ?? r.category_name ?? r.title ?? "",
  //           status:
  //   r.is_active === 1 ||
  //   r.is_active === "1" ||
  //   r.status === "Active" ||
  //   r.status === "active"
  //     ? "Active"
  //     : "Inactive",
  //           image: r.image ?? r.image_url ?? "",
  //         }))
  //       );
  //     } catch (e) {
  //       console.log("Main category fetch error:", e?.message);
  //       setRows([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   useEffect(() => {
  //     if (token) loadCats();
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [token]);

  //   /* ===========================
  //      ✅ ADD (FormData + image)
  //   ============================ */
  //   const addCategory = async (payload) => {
  //     try {
  //       setLoading(true);

  //       const fd = new FormData();
  //       fd.append("name", payload.name);
  //       fd.append("status", payload.status || "Active");
  //       if (payload.imageFile) fd.append("image", payload.imageFile);

  //       const res = await fetch(`${API_BASE}/vendor/main_categories/add.php`, {
  //         method: "POST",
  //         headers: authHeaders,
  //         body: fd,
  //       });

  //       const text = await res.text();
  //       let data = {};
  //       try {
  //         data = JSON.parse(text);
  //       } catch {}

  //       if (!res.ok || data?.success === false) {
  //         alert(data?.message || text || "Add failed");
  //         return;
  //       }

  //       setOpenAdd(false);
  //       await loadCats();
  //     } catch (e) {
  //       alert(e?.message || "Add failed");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   /* ===========================
  //      ✅ OPEN EDIT
  //   ============================ */
  //   const openEditModal = (row) => {
  //     setEditRow(row);
  //     setOpenEdit(true);
  //   };

  //   /* ===========================
  //      ✅ UPDATE (Edit Save)
  //      - calls update.php
  //   ============================ */
  //   const updateCategory = async (payload) => {
  //     // payload should have: id, name, status
  //     try {
  //       setLoading(true);

  //       const res = await fetch(`${API_BASE}/vendor/main_categories/update.php`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           ...authHeaders,
  //         },
  //         body: JSON.stringify({
  //           id: payload.id,
  //           name: payload.name,
  //           status: payload.status,
  //         }),
  //       });

  //       const text = await res.text();
  //       let data = {};
  //       try {
  //         data = JSON.parse(text);
  //       } catch {}

  //       if (!res.ok || data?.success === false) {
  //         alert(data?.message || text || "Update failed");
  //         return;
  //       }

  //       setOpenEdit(false);
  //       setEditRow(null);
  //       await loadCats();
  //     } catch (e) {
  //       alert(e?.message || "Update failed");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   /* ===========================
  //      ✅ TOGGLE STATUS (uses update.php)
  //   ============================ */
  //   const toggleStatus = async (row) => {
  //     const nextStatus = row.status === "Active" ? "Inactive" : "Active";
  //     await updateCategory({ id: row.id, name: row.name, status: nextStatus });
  //   };

  //   /* ===========================
  //      ✅ DELETE
  //   ============================ */
  //   const remove = async (id) => {
  //     if (!window.confirm("Delete this category?")) return;

  //     try {
  //       setLoading(true);

  //       const res = await fetch(`${API_BASE}/vendor/main_categories/delete.php`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           ...authHeaders,
  //         },
  //         body: JSON.stringify({ id }),
  //       });

  //       const text = await res.text();
  //       let data = {};
  //       try {
  //         data = JSON.parse(text);
  //       } catch {}

  //       if (!res.ok || data?.success === false) {
  //         alert(data?.message || text || "Delete failed");
  //         return;
  //       }

  //       await loadCats();
  //     } catch (e) {
  //       alert(e?.message || "Delete failed");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   /* ===========================
  //      ✅ Search
  //   ============================ */
  //   const filtered = useMemo(() => {
  //     const s = q.trim().toLowerCase();
  //     if (!s) return rows;
  //     return rows.filter((r) => (r.name || "").toLowerCase().includes(s));
  //   }, [rows, q]);

  //   return (
  //     <div className="mc-page">
  //       <div className="mc-head">
  //         <h1 className="mc-title">Main Categories</h1>

  //         <div className="mc-tools">
  //           <div className="mc-search">
  //             <span className="mc-searchIcon">🔎</span>
  //             <input
  //               value={q}
  //               onChange={(e) => setQ(e.target.value)}
  //               placeholder="Search category..."
  //             />
  //           </div>

  //           <button className="mc-addBtn" onClick={() => setOpenAdd(true)}>
  //             + Add Main Category
  //           </button>
  //         </div>
  //       </div>

  //       <div className="mc-card">
  //         <table className="mc-table">
  //           <thead>
  //             <tr>
  //               <th style={{ width: 80 }}>S.NO</th>
  //               <th>NAME</th>
  //               <th style={{ width: 160 }}>STATUS</th>
  //               <th style={{ width: 160 }}>IMAGE</th>
  //               <th style={{ width: 200 }}>ACTIONS</th>
  //             </tr>
  //           </thead>

  //           <tbody>
  //             {loading ? (
  //               <tr>
  //                 <td colSpan={5} className="mc-empty">
  //                   Loading...
  //                 </td>
  //               </tr>
  //             ) : filtered.length === 0 ? (
  //               <tr>
  //                 <td colSpan={5} className="mc-empty">
  //                   No categories found
  //                 </td>
  //               </tr>
  //             ) : (
  //               filtered.map((r, idx) => (
  //                 <tr key={r.id}>
  //                   <td>{idx + 1}</td>

  //                   <td className="mc-nameCell">{r.name}</td>

  //                   <td>
  //                     <span className={`mc-status ${r.status === "Active" ? "on" : "off"}`}>
  //                       ● {r.status}
  //                     </span>
  //                   </td>

  //                   <td>
  //                     <button
  //                       className="mc-viewBtn"
  //                       type="button"
  //                       onClick={() => setViewImg(r.image || "")}
  //                     >
  //                       🖼 View
  //                     </button>
  //                   </td>

  //                   <td className="mc-actions">
  //                     {/* ✅ EDIT NAME (opens modal) */}
  //                     <button
  //                       className="mc-iconBtn"
  //                       type="button"
  //                       title="Edit"
  //                       onClick={() => openEditModal(r)}
  //                     >
  //                       ✏️
  //                     </button>

  //                     {/* ✅ TOGGLE STATUS */}
  //                     {/* <button
  //                       className="mc-iconBtn"
  //                       type="button"
  //                       title="Toggle Status"
  //                       onClick={() => toggleStatus(r)}
  //                     >
  //                       🔁
  //                     </button> */}

  //                     {/* ✅ DELETE */}
  //                     <button
  //                       className="mc-iconBtn danger"
  //                       type="button"
  //                       title="Delete"
  //                       onClick={() => remove(r.id)}
  //                     >
  //                       🗑️
  //                     </button>
  //                   </td>
  //                 </tr>
  //               ))
  //             )}
  //           </tbody>
  //         </table>
  //       </div>

  //       {/* ✅ ADD MODAL */}
  //       {openAdd && (
  //         <AddMainCategoryModal
  //           onClose={() => setOpenAdd(false)}
  //           onSave={addCategory}
  //         />
  //       )}

  //       {/* ✅ EDIT MODAL (reuse same modal) */}
  //       {openEdit && editRow && (
  //         <AddMainCategoryModal
  //           mode="edit"
  //           initialData={editRow}
  //           onClose={() => {
  //             setOpenEdit(false);
  //             setEditRow(null);
  //           }}
  //           onUpdate={updateCategory}
  //         />
  //       )}

  //       {/* ✅ VIEW IMAGE */}
  //       {viewImg !== "" && (
  //         <div className="mc-overlay" onMouseDown={() => setViewImg("")}>
  //           <div className="mc-imgModal" onMouseDown={(e) => e.stopPropagation()}>
  //             <div className="mc-imgHead">
  //               <b>Category Image</b>
  //               <button className="mc-x" onClick={() => setViewImg("")}>
  //                 ✕
  //               </button>
  //             </div>

  //             {viewImg ? (
  //               <img src={viewImg} alt="category" className="mc-img" />
  //             ) : (
  //               <div className="mc-noimg">No image</div>
  //             )}
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // }

  import React, { useEffect, useMemo, useState } from "react";
  import AddMainCategoryModal from "./AddMainCategoryModal";
  import EditMainCategoriesModal from "./EditMainCategoryModal";
  import "./mainCategories.css";

  import { API_BASE } from "../../services/apiFetch";
  import { useVendorAuth } from "../../store/vendorAuthStore";

  export default function MainCategoriesPage() {
    const { token } = useVendorAuth();

    const [rows, setRows] = useState([]);
    const [q, setQ] = useState("");
    const [openAdd, setOpenAdd] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const [viewImg, setViewImg] = useState("");
    const [loading, setLoading] = useState(false);

    const authHeaders = token ? { Authorization: "Bearer " + token } : {};

    const loadCats = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/vendor/main_categories/list.php`, { headers: authHeaders });
        const text = await res.text();
        let data = {};
        try { data = JSON.parse(text); } catch { data = {}; }
        const list = data?.categories || data?.data || [];
        if (!res.ok || data?.success === false) { setRows([]); return; }
        const safe = Array.isArray(list) ? list : [];
        setRows(safe.map((r) => ({
          ...r,
          id: Number(r.id ?? r.category_id ?? 0),
          name: r.name ?? r.category_name ?? r.title ?? "",
          status: r.is_active === 1 || r.is_active === "1" || r.status === "Active" || r.status === "active" ? "Active" : "Inactive",
          image: r.image ?? r.image_url ?? "",
        })));
      } catch (e) {
        console.log("Main category fetch error:", e?.message);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (token) loadCats();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const addCategory = async (payload) => {
      try {
        setLoading(true);
        const fd = new FormData();
        fd.append("name", payload.name);
        fd.append("status", payload.status || "Active");
        if (payload.imageFile) fd.append("image", payload.imageFile);
        const res = await fetch(`${API_BASE}/vendor/main_categories/add.php`, { method: "POST", headers: authHeaders, body: fd });
        const text = await res.text();
        let data = {};
        try { data = JSON.parse(text); } catch {}
        if (!res.ok || data?.success === false) { alert(data?.message || text || "Add failed"); return; }
        setOpenAdd(false);
        await loadCats();
      } catch (e) { alert(e?.message || "Add failed"); }
      finally { setLoading(false); }
    };

    const updateCategory = async (payload) => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/vendor/main_categories/update.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json", ...authHeaders },
          body: JSON.stringify({ id: payload.id, name: payload.name, status: payload.status }),
        });
        const text = await res.text();
        let data = {};
        try { data = JSON.parse(text); } catch {}
        if (!res.ok || data?.success === false) { alert(data?.message || text || "Update failed"); return; }
        setOpenEdit(false); setEditRow(null);
        await loadCats();
      } catch (e) { alert(e?.message || "Update failed"); }
      finally { setLoading(false); }
    };

    const remove = async (id) => {
      if (!window.confirm("Delete this category?")) return;
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/vendor/main_categories/delete.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json", ...authHeaders },
          body: JSON.stringify({ id }),
        });
        const text = await res.text();
        let data = {};
        try { data = JSON.parse(text); } catch {}
        if (!res.ok || data?.success === false) { alert(data?.message || text || "Delete failed"); return; }
        await loadCats();
      } catch (e) { alert(e?.message || "Delete failed"); }
      finally { setLoading(false); }
    };

    const filtered = useMemo(() => {
      const s = q.trim().toLowerCase();
      if (!s) return rows;
      return rows.filter((r) => (r.name || "").toLowerCase().includes(s));
    }, [rows, q]);

    return (
      <div className="mc-page">

        {/* Header */}
        <div className="mc-header">
          <div className="mc-header-left">
            <div className="mc-header-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
                <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
              </svg>
            </div>
            <div>
              <h1 className="mc-title">Main Categories</h1>
              <p className="mc-subtitle">{rows.length} {rows.length === 1 ? "category" : "categories"} total</p>
            </div>
          </div>
          <button className="mc-add-btn" onClick={() => setOpenAdd(true)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add Category
          </button>
        </div>

        {/* Toolbar */}
        <div className="mc-toolbar">
          <div className="mc-search">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search categories…" />
            {q && (
              <button className="mc-search-clear" onClick={() => setQ("")}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            )}
          </div>
          <div className="mc-count">
            Showing <strong>{filtered.length}</strong> of <strong>{rows.length}</strong>
          </div>
        </div>

        {/* Cards */}
        {loading ? (
          <div className="mc-state">
            <div className="mc-spinner" />
            <p>Loading categories…</p>
          </div>
        ) : filtered.length === 0 ? (
          <div className="mc-state">
            <div className="mc-empty-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
                <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
              </svg>
            </div>
            <p className="mc-empty-title">{q ? "No results found" : "No categories yet"}</p>
            <p className="mc-empty-sub">{q ? `No categories match "${q}"` : "Click Add Category to get started"}</p>
          </div>
        ) : (
          <div className="mc-grid">
            {filtered.map((r) => (
              <div className="mc-card" key={r.id}>
                {/* Image */}
                <div className="mc-card-img" onClick={() => setViewImg(r.image || "")}>
                  {r.image ? (
                    <img src={r.image} alt={r.name}
                      onError={(e) => { e.currentTarget.style.display = "none"; e.currentTarget.nextSibling.style.display = "flex"; }} />
                  ) : null}
                  <div className="mc-card-img-fallback" style={{ display: r.image ? "none" : "flex" }}>
                    {r.name?.charAt(0)?.toUpperCase() || "?"}
                  </div>
                  <div className="mc-card-img-overlay">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                    </svg>
                  </div>
                </div>

                {/* Body */}
                <div className="mc-card-body">
                  <div className="mc-card-top">
                    <h3 className="mc-card-name">{r.name}</h3>
                    <span className={`mc-badge ${r.status === "Active" ? "mc-badge-green" : "mc-badge-gray"}`}>
                      <span className="mc-badge-dot" />{r.status}
                    </span>
                  </div>
                  <div className="mc-card-footer">
                    <button className="mc-icon-btn mc-icon-edit" title="Edit"
                      onClick={() => { setEditRow(r); setOpenEdit(true); }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                      Edit
                    </button>
                    <button className="mc-icon-btn mc-icon-delete" title="Delete" onClick={() => remove(r.id)}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                        <path d="M10 11v6"/><path d="M14 11v6"/>
                        <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                      </svg>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {openAdd && <AddMainCategoryModal onClose={() => setOpenAdd(false)} onSave={addCategory} />}
        {openEdit && editRow && (
          <EditMainCategoriesModal
            initialData={editRow}
            onClose={() => { setOpenEdit(false); setEditRow(null); }}
            onUpdate={updateCategory}
          />
        )}

        {viewImg !== "" && (
          <div className="mc-overlay" onMouseDown={() => setViewImg("")}>
            <div className="mc-img-modal" onMouseDown={(e) => e.stopPropagation()}>
              <div className="mc-img-head">
                <span className="mc-img-title">Category Image</span>
                <button className="mc-close-btn" onClick={() => setViewImg("")}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
              {viewImg ? <img src={viewImg} alt="category" className="mc-img" /> : <div className="mc-no-img">No image uploaded</div>}
            </div>
          </div>
        )}
      </div>
    );
  }